const maxCharactersPerMessage = 300
export default maxCharactersPerMessage;